import React, { useState, useEffect } from 'react';
import SelectOrders from "./SelectOrders";
import {
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";

const OrderManager = ({ 
  selectedOrders = [], 
  onOrdersChange, 
  accountNumber
}) => {
  const [showOrderDialog, setShowOrderDialog] = useState(false);
  const [internalSelectedOrders, setInternalSelectedOrders] = useState(selectedOrders);

  // Sync internal state with props
  useEffect(() => {
    setInternalSelectedOrders(selectedOrders);
  }, [selectedOrders]);

  const handleAddOrders = () => {
    setShowOrderDialog(true);
  };

  const handleRemoveOrder = (orderNumber) => {
    const updatedOrders = internalSelectedOrders.filter(order => order !== orderNumber);
    setInternalSelectedOrders(updatedOrders);
    onOrdersChange(updatedOrders);
  };

  const handleClearAll = () => {
    setInternalSelectedOrders([]);
    onOrdersChange([]);
  };

  const handleOrderSelection = (newOrderNumbers) => {
    // Combine existing orders with new ones, avoiding duplicates
    const combinedOrders = [...new Set([...internalSelectedOrders, ...newOrderNumbers])];
    setInternalSelectedOrders(combinedOrders);
    onOrdersChange(combinedOrders);
    setShowOrderDialog(false);
  };

  const handleCloseOrderDialog = () => {
    setShowOrderDialog(false);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1,
          mb: 2,
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{ color: "primary.main", fontWeight: 700 }}
        >
          Selected Orders ({internalSelectedOrders.length})
        </Typography>

        {internalSelectedOrders.length > 0 && (
          <Button
            size="small"
            color="error"
            variant="outlined"
            startIcon={<DeleteSweepIcon />}
            onClick={handleClearAll}
          >
            Clear All
          </Button>
        )}
      </Box>

      {internalSelectedOrders.length > 0 ? (
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
            {internalSelectedOrders.map((orderNumber) => (
              <Chip
                key={orderNumber}
                color="info"
                variant="outlined"
                label={orderNumber}
                onDelete={() => handleRemoveOrder(orderNumber)}
              />
            ))}

            <Button
              size="small"
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleAddOrders}
            >
              Add Orders
            </Button>
          </Stack>
        </Paper>
      ) : (
        <Paper variant="outlined" sx={{ p: 4, textAlign: "center" }}>
          <Typography color="text.secondary">No orders selected</Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            Click "Add Orders" to start selecting orders for comparison.
          </Typography>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleAddOrders}
          >
            Add Orders
          </Button>
        </Paper>
      )}

      <SelectOrders
        open={showOrderDialog}
        onClose={handleCloseOrderDialog}
        onDone={handleOrderSelection}
        accountNumber={accountNumber}
        title="Select Orders for Water Profile Comparison"
        maxSelection={10}
      />
    </Box>
  );
};

export default OrderManager;